import LeftPartModal from "./LeftPartModal";

export default LeftPartModal;
